import { xlCol } from "../../../common/constants";

export const RouteMasterHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 40 },
  { header: "City Name", field: "Cityname", xlCol: xlCol, weight: 90 },
  { header: "Route Zone", field: "RouteZone", xlCol: xlCol, weight: 90 },
  { header: "Route Name", field: "RouteName", xlCol: xlCol, weight: 100 },
  { header: "Route Area", field: "RouteArea", xlCol: xlCol, weight: 180 },
  { header: "Modified By", field: "Modifiedby", xlCol: xlCol, weight: 110 },
  { header: "Modified Date & Time", field: "ModifiedDateTime", xlCol: xlCol, weight: 140 },
  { header: "Status", field: "Status_view", xlCol: xlCol, weight: 70, align: 'center' },
  { header: "Edit", field: "Edit", xlCol: xlCol, weight: 20, ViewOnly: true, align: 'center' }
];

export const RouteMasterHeaFilterHeaders = [
  { field: 'selCity', header: 'City', textAlign: 'left' },
  { field: 'routeZone', header: 'Route Zone', textAlign: 'left' },
  { field: 'Status', header: 'Status', textAlign: 'left' },
]
export const routeZones = [
  { id: 0, name: "All" },
  { id: 1, name: "North (N)" },
  { id: 2, name: "East (E)" },
  { id: 3, name: "South (S)" },
  { id: 4, name: "West (W)" },
  { id: 5, name: "Northeast (NE)" },
  { id: 6, name: "Southeast (SE)" },
  { id: 7, name: "Northwest (NW)" },
  { id: 8, name: "Southwest (SW)" }
];
export const statusList = [
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
  { id: -1, name: 'All' }
]
